
export interface IBaseModel {
    id?: string;
    schema?: string;
    ttl?: number;
}
export enum AccountStatus {
    approved = 1,
    PendingAdminApproval = 0,
    PendingEmailVerification = -1
}
export interface ILoginResonse {
    accessToken: string;
    userId: string;
    refreshToken: string;
    status: number;
    email: string;
    username: string;
    date: string;
    name: string;
    role: string;
    organisation?: IOrganisation;
    // tslint:disable-next-line:no-any
    groups?: any[];
    // tslint:disable-next-line:no-any
    courses?: any[];
    role_object?: IRole;
    user: IUser;
}
export interface IGroup extends IBaseModel {
    name?: string;
    parent_id?: string;
}
export interface IRole extends IBaseModel {
    name?: string;
    push_channel?: string;
    age_group?: string;
    emailOptional?: boolean;
}
export interface ICourse extends IBaseModel {
    code?: string;
    name?: string;
    thumbnail_url?: string;
    summary?: string;
    price?: string;
    age_group?: string[];
    owner_code?: string;
    owner_name?: string;
    is_public?: string;
    created_time?: string;
    updated_time?: string;
    modules?: IModule[];
}

export interface IModule {
    code?: string;
    name?: string;
    created_time?: string;
    updated_time?: string;
    test?: ITestData;
    quiz?: IQuizData;
    pages?: IPage[];
}
export interface IPinCode {
    code: string;
    username: string;
    identifier: string;
    created_time: string;
}
export interface IPage {
    title?: string;
    video_link?: string;
    menu_icon?: string;
    audio_file_link?: string;
    html_filename?: string;
}
export interface ITestData {
    passcode?: string;
    release_time?: string;
    title?: string;
    icon?: string;
    header?: IHeader;
    url?: string;
}
export interface IHeader {
    video?: string;
    image?: string;
}
export interface IQuizData {
    title?: string;
    icon?: string;
    header?: IHeader;
    url?: string;
}
export interface IEmailHost {
    host?: string;
    role_ids?: string[];
}
export interface IAccessCode {
    access_code?: string;
    expiry_date?: string;
    role_id?: string;
}
export interface ILoginCode {roleId: string; code: string; qrCodeLink: string; }

export interface IOrganisation extends IBaseModel {
    parent_id?: string;
    parent_code?: string;
    name: string;
    code: string;
    created_time?: string;
    max_accounts?: string;
    updated_time?: string;
    certificate_from?: string;
    url?: string;
    groups?: IGroup[];
    roles?: IRole[];
    courses?: ICourse[];
    email_hosts?: IEmailHost[];
    access_codes?: IAccessCode[];
    calendar_events?: ICalendarEvent[];
    queued_push_notifications?: IPushNotification[];
    processed_push_notifications?: IPushNotification[];
    hide_score?: Boolean;
    organisation_surveys?: OrganisationSurvey[];
    organisationSurveysEnabled?: boolean;
    hide_percent_sign?: Boolean;
    save_public_results?: Boolean;
    firebase_key?: string;
    child_organisations?: IOrganisation[];
    appData?: IAppData;
    isPublic?: boolean;
    allowReadOnlyAccess?: boolean;
    loginCodes?: ILoginCode[];
    group_chat_pin_codes?: IPinCode[];
}

export interface ICalendarEvent extends IBaseModel {
    date_time?: string;
    title?: string;
    description?: string;
    location?: string;
    postcode?: string;
    category?: ICalendarCategory;
    alertOnAdd?: IPushNotification;
    reminder?: IPushNotification;
}

export interface ICalendarCategory {
    name: string;
    color: string;
}

export interface IPushNotification extends IBaseModel {
    user?: IUser;
    organisation_code?: string;
    roles?: string[];
    groups?: string[];
    title?: string;
    body?: string;
    app_url?: string[];
    created_time?: string;
    sending_time?: string;
    processed_time?: string;
    payload_data?: {
        [key: string]: string;
    };
    deleted?: boolean;
}
export interface IPasswordResetCode extends IBaseModel {
    user_id?: string;
    email?: string;
    code?: string;
    expiry_date?: string;
}
export interface IResult extends IBaseModel {
    submit_time?: string;
    submitted_name?: string;
    score?: number;
    groupId?: string;
    groupName?: string;
    certificate_score?: string;
    role_id?: string;
    role_name?: string;
    course?: string;
    course_name?: string;
    module?: string;
    module_name?: string;
    certificate_url?: string;
    username?: string;
    userId?: string;
    additionalData?: ResultAdditionalData;
}

export interface OrganisationSurvey {
    id?: string;
    roles?: string[];
    name?: string;
    link?: string;
    created_time?: string;
    username?: string;
}

interface ResultAdditionalData {
    customOrganisation?: string;
    club?: string;
    sport?: string;
}

export interface IUser extends IBaseModel {
    name?: string;
    password?: string;
    email?: string;
    organisationName?: string;
    username?: string;
    is_shared?: boolean;
    is_admin?: boolean;
    status?: number;
    created_time?: string;
    updated_time?: string;
    organisation_id?: string;
    organisation?: string;
    role?: IRole;
    groups?: IGroup[];
    results?: IResult[];
    device_ids?: string[];
    courses?: ICourse[];
    accessToken?: string;
    refreshToken?: string;
    lastAuthenticated ?: string;

}
export interface IBaseEmailTemplate {
    subject?: string;
    templateKey?: string;
    greeting?: string;
    recpient?: string;
    message?: string;
}
export interface IBaseToken extends IBaseModel {
    userID?: string;
    token?: string;
    type?: TokenType;
}
export interface IAccessToken extends IBaseToken {
    fullUsername?: string;
    organisationCode?: string;
    isAdmin?: Boolean;
    created_date?: string;
    organisationId?: string;
}

export interface IRefreshToken extends IBaseToken {
    used_date?: string;
}

export interface IAppData {
    organisationCode?: string;
    organisationId?: string;
    appTint?: IAppTint;
    menu: IMenu;
    shareAction?: IShareAction;
}
export interface IShareAction {
    name?: string;
    shortName?: string;
    url?: string;
}

export interface IAppTint {
    color?: string;
    gradient?: IAppGradient;
}
export interface IAppGradient {
    type?: string;
    color?: string[];
}
export interface IMenu {
   news?: INewsMenuSection;
   more?: IMoreMenuSection;
   // tslint:disable-next-line:no-any
   courses?: any;
   // tslint:disable-next-line:no-any
   testing?: any;
    
}
export interface IBaseMenuSection {
    requiresLogin?: boolean;
    icon?: string;
    text?: string;
}
export interface INewsMenuSection extends IBaseMenuSection {
    items?: INewsMenuItem[];
}
export interface INewsMenuItem {
    requiresLogin?: string;
    headerTextColor?: string;
    name?: string;
    roles?: string[];
    color?: string;
    gradient?: IAppGradient;
    url?: string;
    notificationQueryParams?: string[];
}

export interface IMoreMenuSection extends IBaseMenuSection {
    items?: IMoreMenuItem[];
}
export interface IMoreMenuItem {
    requiresLogin?: string;
    name?: string;
    roles?: string[];
    icon?: string;
    type?: MoreItemType;
    url?: string;
    notificationQueryParams?: string[];
}

export enum MoreItemType {
    StaffDirectory,
    H2bSaferUpdates,
    HTMLPage,
    Calendar,
    WebView
}

export enum TokenType {
    AccessToken = "AUTH",
    RefreshToken = "REFRESH"
}
export interface NotificationAppUrlSection {
    name: string;
    items: NotificationAppUrlItem[];
}
export interface NotificationAppUrlItem {
    label: string;
    appUrl: string;
    roles: string[];
    requiresLogin: string;
    extras: {
        label?: string;
        key?: string;
        value?: string;
    }[];
}



// WEBPACK FOOTER //
// ./src/model/ModelTypes.ts